import { createMeta } from "../../../components/TapHeader";

const title = "Candidates";
export const MyCandidatesMeta = createMeta(title);
